import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'listFilter',
    standalone: false
})
export class ListFilterPipe implements PipeTransform {

  transform(items: any[], column: string, value: any): any {
    if (!items || !column || !value) {
        return items;
    }
    /* 
      ADD A NEW CASE WITH THE COLUMN THAT THE PIPE SHOULD USE 
      AND INTEGRATE THE PIPE FOR ANY LIST FILTERING 
    */
    switch (column) {
      case 'ID':
        return items.filter(item => item.id.indexOf(value) !== -1);
        break;

      case 'PARENT':
        return items.filter(item => item.parent.indexOf(value) !== -1);
        break;

      case 'GROUP':
        return items.filter(item => item.group.indexOf(value) !== -1);
        break;

      case 'ISPERMIT':
        return items.filter(item => item.isPermit === value);
        break;

      case 'VISIBLE':
        return items.filter(item => item.visible === value);
        break;

        case 'COMPANYID':
        return items.filter(item => item.empresaId === value);
        break;

      case 'DOCTORID':
        return items.filter(item => item.medicoId === value);
        break;
      default:
        return items;
        break;
    }
}

}
